export const formItemMixins = {
  data() {
    return {
      inputItems: [
        { type: 'Input', label: '单行文本', tqType: 'string', icon: 'md-create' },
        // { type: 'SelectRemote', label: '联想文本', tqType: 'string', icon: 'ios-bulb' },
        { type: 'Textarea', label: '多行文本', tqType: 'string', icon: 'ios-create' },
        { type: 'InputNumber', label: '计数器', tqType: 'number', icon: 'ios-grid' },
      ],
      selectItems: [
        { type: 'Select', label: '下拉选择', tqType: 'string', icon: 'md-git-branch' },
        { type: 'Cascader', label: '级联选择', tqType: 'string', icon: 'md-git-compare' },
        { type: 'Radio', label: '单选组件', tqType: 'string', icon: 'ios-radio-button-on' },
        { type: 'Checkbox', label: '多选组件', tqType: 'array', icon: 'ios-checkbox' },
        { type: 'Switch', label: '开关', tqType: 'boolean', icon: 'ios-switch' },
        { type: 'DatePicker', label: '日期选择', tqType: 'string', icon: 'ios-calendar' },
        { type: 'TimePicker', label: '时间选择', tqType: 'string', icon: 'ios-clock' },
        { type: 'Rate', label: '评分', tqType: 'number', icon: 'ios-star-half' },
        { type: 'Upload', label: '文件上传', tqType: 'array', icon: 'md-cloud-upload' },
        { type: 'Avatar', label: '头像上传', tqType: 'string', icon: 'ios-contact' },
      ],
      layoutItems: [
        { type: 'Row', label: '行容器', tqType: 'any', icon: 'md-grid' },
        { type: 'Button', label: '按钮', tqType: 'any', icon: 'ios-paw' },
        { type: 'Title', label: '标题', tqType: 'any', icon: 'logo-wordpress' },
        { type: 'Space', label: '空格', tqType: 'any', icon: 'md-qr-scanner' },
      ],
    }
  },
  methods: {
    // 组件名称  定义的类型 和 iview 类型的转换
    componentsName(type) {
      if (type === 'Password' || type === 'Textarea' || type === 'Input') {
        return 'input'
      }
      if (type === 'SelectRemote' || type === 'Select') {
        return 'select'
      }
      return type.toLocaleLowerCase()
    },
  },
}

export const baseComponentMixins = {
  props: {
    info: {
      type: Object,
      default() {
        return {
          form: {},
        }
      },
    },
    size: {
      type: String,
      default: 'default',
    },
  },
}